import {
  DropdownListProps,
  DropdownList,
  DropdownListGroup,
  DropDownLabel,
  OptionType
} from "elements";
import { ErrorMessage, FieldProps, useField } from "formik";
import React from "react";

export type SelectProps = Omit<DropdownListProps, keyof FieldProps["field"]> & {
  name: string;
  /**
   * Perform a side effect on the field changing, the value is still forkmik managed.
   * @param val
   */
  onSelectionChange?: (val: OptionType["value"]) => void;
  disabled?: boolean;
  dividerIndices?: Array<number>;
};
export const FormikSelect: React.FC<SelectProps & { value?: any }> = props => {
  const [{ onChange, value }, , { setTouched }] = useField(props.name);
  const { onSelectionChange, disabled, dividerIndices } = props;

  return (
    <DropdownList
      onOpen={() => setTouched(true)}
      onChange={val => {
        onSelectionChange && onSelectionChange(val);
        onChange({ target: { name: props.name, value: val } });
      }}
      value={`${props.value ?? value ?? ""}`}
      {...props}
      disabled={disabled}
      dividerIndices={dividerIndices}
    />
  );
};
export const Select: React.FC<SelectProps & { value?: any }> = props => {
  const [, { error, touched }] = useField(props.name);
  let wrapClasses = "";

  if (error && touched) {
    wrapClasses = "has-error touched";
  }

  return (
    <div className={wrapClasses}>
      <FormikSelect
        {...props}
        disabled={!!props.disabled}
        dividerIndices={props.dividerIndices}
      />
      <ErrorMessage
        component="div"
        className="error-message"
        data-testid={`${props.name}-errormsg`}
        name={props.name}
      />
    </div>
  );
};
export const LabeledSelect: React.FC<SelectProps & { label: string }> = ({
  label,
  ...rest
}) => {
  const [{ value }] = useField(rest.name);
  return (
    <DropdownListGroup>
      <DropDownLabel label={label} value={value} name={rest.name} />
      <FormikSelect {...rest} placeholder={label} />
    </DropdownListGroup>
  );
};
export const StandardFormSelect: React.FC<SelectProps & { label: string }> = ({
  label,
  ...rest
}) => {
  const [{ value }] = useField(rest.name);
  return (
    <DropdownListGroup>
      <DropDownLabel label={label} value={value} name={rest.name} />
      <Select {...rest} placeholder={label} />
    </DropdownListGroup>
  );
};
